import { transformObjectValuesToObject } from '@/shared/utils/transformObjectValuesToObject';
import { ValuesOf } from '@/shared/utils/types';

const OnboardingStep = {
  welcome: 'welcome',
  hello: 'hello',
  payouts: 'payouts',
  payment: 'payment_info',
} as const;

type TOnboardingStep = ValuesOf<typeof OnboardingStep>;

interface IOnboarding {
  isCompleted: boolean;
  lastStepName: TOnboardingStep;
  isLastStepCompleted: boolean;
}

const OnboardingStepsEnum = transformObjectValuesToObject<TOnboardingStep>(OnboardingStep);

export { OnboardingStep, OnboardingStepsEnum };
export type { IOnboarding, TOnboardingStep };
